<template>
  <div class="q-pt-md q-mb-md">
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      :filter="filter"
      :rows="rows"
      :columns="columns"
      dense
      :loading="disable"
      class="tabela-tamanho-fixo"
      v-model:pagination="pagination"
      hide-pagination
      @request="handleRequest"
    >
      <template v-slot:top-right>
        <q-input
          outlined
          rounded
          dense
          debounce="300"
          v-model="filter"
          placeholder="Buscar"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template #body-cell-selecionados="props">
        <q-td>
          <q-checkbox
            v-if="!props.row.pivot.product_group"
            size="md"
            :disabled="props.row.pivot.product_group"
            v-model="selecionados"
            :val="props.row.pivot.product_id"
          />
        </q-td>
      </template>
      <template #body-cell-created_at="props">
        <q-td>
          {{
            props.row.created_at.split(" ")[0].split("-").reverse().join("/")
          }}
          {{ props.row.created_at.split(" ")[1] }}
        </q-td>
      </template>
      <template #body-cell-grupo="props">
        <q-td>
          <span v-if="!props.row.pivot.product_group">Sem Grupo</span>

          <span v-else>{{ props.row.pivot.product_group.name }}</span>
        </q-td>
      </template>
      <template #body-cell-image="props">
        <q-td>
          <q-img
            v-if="props.row.product_images[0]"
            :src="props.row.product_images[0].url"
            spinner-color="white"
            height="65px"
            width="95px"
            fit="contain"
            no-native-menu
          />
        </q-td>
      </template>
      <template #body-cell-price="props">
        <q-td>
          R$
          {{ Number(props.row.pivot.price).toFixed(2) }}
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>

    <q-btn
      @click="adicionarProdutoGrupo"
      color="positive"
      label="Adicionar"
      class="q-mt-lg"
    />
  </div>
</template>

<script>
const columns = [
  {
    name: "selecionados",
    label: "Selecionar",
    field: "selecionados",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "produtoId",
    label: "ID",
    field: (row) => row.id,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "id",
    label: "Codigo",
    field: (row) => row.code,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "description",
    label: "Descrição",
    field: (row) => row?.pivot?.contract_product_description,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "grupo",
    label: "Grupo",
    field: "name",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "image",
    label: "Imagem",
    field: "image",
    align: "left",
    style: "white-space: normal",
  },

  {
    name: "categoria",
    label: "Categoria",
    field: (row) =>
      row.pivot.product_category
        ? row.pivot.product_category.code
        : "Sem Categoria",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "description",
    label: "CA",
    field: (row) =>
      row.pivot && row.pivot.ca != null ? row.pivot.ca.code : "Sem CA",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "price",
    label: "Preço",
    field: "price",
    align: "left",
    style: "white-space: normal",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
export default {
  props: ["associacao"],
  setup(props, { emit }) {
    const $q = useQuasar();
    const route = useRoute();
    const store = useStore();
    const rows = ref([]);
    const disable = ref(true);
    const selecionados = ref([]);
    let filter = ref("");
    const dados = JSON.parse(route.params.id);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getProdutos = async (page = 1, rowsPerPage = 15) => {
      try {
        let response = await store.dispatch("grupoProdutos/listarProdutos", {
          contract_id: store.state.org.contract,
          per_page: rowsPerPage,
          page: page,
          search: filter.value,
          group_id: props.associacao.value,
        });

        rows.value = response.data.model.products.data;
        pagination.value.rowsPerPage = response.data.model.products.per_page;
        pagination.value.rowsNumber = response.data.model.products.total;
        pagination.value.page = response.data.model.products.current_page;

        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const adicionarProdutoGrupo = async () => {
      emit("atualizar", 1);
      selecionados.value.forEach(async (e) => {
        try {
          let dadosProduto = [{ product_id: e, product_group_id: dados.id }];
          await store.dispatch("grupoProdutos/adicionarProdutoGrupo", {
            products: dadosProduto,
            contract_id: store.state.org.contract,
          });

          $q.notify({
            message: "Produtos adicionados com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getProdutos();
          selecionados.value = [];
        } catch (error) {
          $q.notify({
            message: "Erro a o adicionar produtos",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
    };

    onMounted(() => {
      getProdutos();
    });

    const handleRequest = async () => {
      getProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => props.associacao,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.contract,
      () => {
        getProdutos();
      }
    );

    return {
      dados,
      columns,
      rows,
      getProdutos,
      pagination,
      handleRequest,
      disable,
      filter,
      selecionados,
      adicionarProdutoGrupo,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.circle {
  width: 12px;
  height: 12px;

  border-radius: 50%;
}

.align {
  align-items: center;
}
</style>
